import { optionalTrimmedString } from '../../../lib/routeSearch';
import { agencyPageSizes } from './model';

export interface AgencyRouteSearch {
  search?: string;
  page?: number;
  size?: number;
}
export function agencyRouteSearchSchema(search: Record<string, unknown>): AgencyRouteSearch {
  const term = optionalTrimmedString(search.search);
  const page = Number(search.page);
  const size = Number(search.size);
  return {
    ...(term ? { search: term } : {}),
    ...(Number.isInteger(page) && page > 1 ? { page } : {}),
    ...(agencyPageSizes.some((value) => value === size) && size !== 20 ? { size } : {}),
  };
}
